import { ReactNode, JSX, useEffect, useMemo } from 'react';

import { login } from ':api';
import { Preloader, ErrorComponent } from ':components';
import { AuthContext } from ':constants';
import { useAuthCheck } from ':hooks';

interface Props {
  children: ReactNode;
}

export const AuthProvider = ({ children }: Props): JSX.Element => {
  const { success, error } = useAuthCheck();

  useEffect(() => {
    if (success === false && !error) {
      login();
    }
  }, [success, error]);

  const value = useMemo(() => ({ auth: success ?? false }), [success]);

  if (error) {
    return (
      <>
        <ErrorComponent
          title='Ошибка аутентификации'
          subtitle={
            <>
              Пожалуйста, попробуйте обновить страницу через несколько минут.
              <br />
              Если проблема не исчезнет - обратитесь в Хелпдеск
            </>
          }
          buttonTitle='Обновить'
          onButtonClick={() => {
            window.location.reload();
          }}
        />
      </>
    );
  }

  if (!success) {
    return <Preloader text='Проверка авторизации...' />;
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
